import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import logoImg from "../../assets/images/logo-img.png";
import lightThemeBg from "../../assets/images/light_theme_bg.png";
import "../../assets/css/login-cinematic.css";
import footerCompanyLogo1 from "../../assets/images/AGS.png";
import { useNavigate, useLocation } from "react-router-dom";
import adminToolsService from "../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Checkbox, Form, Input, Modal, Select, Tooltip } from "antd";

const ResetPassword = (props) => {
  const [isLightMode, setIsLightMode] = useState(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setIsLightMode(!e.matches);
    
    // Fallback for older browsers
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);
  const { t } = useTranslation();
  const [Passwordobj, setPasswordObj] = useState({
    password: "",
    confirmPassword: "",
  });
  const [validations, setValidations] = useState({
    passwordVal: "",
    confirmPasswordVal: "",
    CheckSameVal: "",
    passwordRequirementError: false,
  });
  const [visible, setVisible] = useState(false);
  const search = useLocation().search;
  const [token, setToken] = useState("");
  const [email, setemail] = useState("");
  const [loading, setLoading] = useState(false);
  const [updatePasswordModal, setUpdatePasswordModal] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const WhiteLabeling = useSelector((state) => state.loginReducer);
  const { Option } = Select;
  let navigate = useNavigate();
  useEffect(() => {
    const token = new URLSearchParams(search).get("token");
    const email = new URLSearchParams(search).get("email");
    setToken(token);
    setemail(email);
    if (token && email) {
      try {
        let inputData = {
          userEmail: email,
          resetToken: token,
        };
        adminToolsService
          .ForgotPasswordTokenVerify(inputData)
          .then((response) => {
            var message = response.data.message;
            var responseData = response.data.responseData;
            var isSucceed = response.data.responseData.isSucceed;
            if (message === "Success") {
              if (isSucceed) {
                NotificationManager.Success(t("Token Verification Successful"));
                navigate("/");
              } else {
                navigate("/");
              }
            } else {
              navigate("/");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      navigate("/");
    }
  }, []);

  const handleOnChange = (e) => {
    setPasswordObj({
      ...Passwordobj,
      [e.target.name]: e.target.value,
    });
  };

  const handleValidation = () => {
    const validations = {
      confirmPasswordVal: "",
      passwordVal: "",
      CheckSameVal: "",
      passwordRequirementError: false,
    };
    let isValid = true;
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,15})"
    );

    if (!Passwordobj.password) {
      isValid = false;
      validations.passwordVal = "Password is compulsory";
    } else if (!Passwordobj.password.match(strongRegex)) {
      isValid = false;
      validations.passwordRequirementError = true;
    } else {
      validations.passwordVal = "";
    }
    if (!Passwordobj.confirmPassword) {
      isValid = false;
      validations.confirmPasswordVal = "Confirm Password is compulsory";
    } else if (!Passwordobj.confirmPassword.match(strongRegex)) {
      isValid = false;
      validations.passwordRequirementError = true;
    } else {
      validations.confirmPasswordVal = "";
    }
    if (password && confirmPassword) {
      if (password !== confirmPassword) {
        isValid = false;
        validations.CheckSameVal = "Both Passwords Must Match";
      } else {
        validations.CheckSameVal = "";
      }
    }

    setValidations(validations);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = handleValidation();
    if (!isValid) {
      setUpdatePasswordModal(false);
      return false;
    }
    try {
      let inputData = {
        userEmail: email,
        resetToken: token,
        password: Passwordobj.password,
      };
      setLoading(true);
      adminToolsService
        .ForgotPasswordChangeNewPassword(inputData)
        .then((response) => {
          var message = response.data.message;
          var isSucceed = response.data.responseData.isSucceed;

          if (message == "True") {
            if (isSucceed) {
              NotificationManager.success(t("Password Changed Successfully"));
              setUpdatePasswordModal(false);
              navigate("/");
              setLoading(false);
            } else {
              var errMsg = response.data.responseData.errMsg;
              if (errMsg) {
                NotificationManager.error(t(errMsg));
              } else {
                NotificationManager.error(t("Password Changed Fail"));
              }
              setUpdatePasswordModal(false);
              setLoading(false);
            }
          } else {
            var errMsg = response.data.responseData?.errMsg;
            if (errMsg) {
              NotificationManager.error(t(errMsg));
            } else {
              NotificationManager.error(t("Password Changed Fail"));
            }
            setUpdatePasswordModal(false);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setPasswordObj({
      password: "",
      confirmPassword: "",
    });
    setValidations({
      passwordVal: "",
      confirmPasswordVal: "",
    });
  };

  const handlePasswordModal = () => {
    const isValid = handleValidation();
    if (!isValid) {
      return false;
    }
    setUpdatePasswordModal(true);
  };

  const handleCancelModal = () => {
    setUpdatePasswordModal(false);
  };

  const handlePassShowHide = () => {
    setshowPassword(!showPassword);
  };

  const handleConfirmPassShowHide = () => {
    setshowConfirmPassword(!showConfirmPassword);
  };

  const { password, confirmPassword } = Passwordobj;
  const { passwordVal, confirmPasswordVal, CheckSameVal, passwordRequirementError } = validations;

  const handleOpenLink = (link) => {
    window.open(link, "__blank");
  };

  return (
    <div className={`login-cinematic-container ${isLightMode ? 'light-theme' : ''}`}>
      {/* Top Header overlay */}
      <div className="login-cinematic-top-header">
        <img
          src={WhiteLabeling?.whiteLebelData?.[0]?.logoImage || logoImg}
          alt="Logo"
          className="top-header-logo"
          onClick={() => navigate("/")}
        />
        <div className="d-none d-md-block" style={{ color: '#f8fafc', fontSize: '13px', letterSpacing: '2px', fontWeight: '500', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
          SOCIAL PRODUCT NETWORK FOR THE JEWELRY INDUSTRY
        </div>
      </div>

      <div className="login-cinematic-split-screen">
        <div 
          className="login-cinematic-image-side" 
          style={{ backgroundImage: `url(${lightThemeBg})` }}
        ></div>
        
        <div className="login-cinematic-form-side" style={{ position: 'relative' }}>
          
          <div className="login-cinematic-login-card pt-5">
            <h2>Reset Password</h2>
            <p style={{ color: passwordRequirementError ? "red" : "#1890ff", fontSize: "12px", marginTop: "4px", marginBottom: "20px" }}>
              Password must contain minimum 8 characters, at least
              one uppercase letter, one lowercase letter, one number
              and one special character
            </p>
            <div>
              {CheckSameVal && (
                <p className="error-color-red" style={{ marginBottom: "1rem" }}>{CheckSameVal}</p>
              )}
            </div>

            <Form
               name="basic"
               onFinish={handlePasswordModal}
            >
              <div className="login-cinematic-input-wrapper">
                <Form.Item style={{ marginBottom: "1rem" }}>
                  <div style={{ position: 'relative' }}>
                    <Input 
                      className="login-input" 
                      placeholder="New Password"
                      name="password"
                      value={password}
                      onChange={handleOnChange}
                      type={showPassword ? "text" : "password"}
                      style={{ paddingRight: '48px', borderColor: passwordVal ? 'red' : undefined }}
                    />
                    <span 
                      onClick={handlePassShowHide}
                      style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94a3b8', zIndex: 10, display: 'flex', alignItems: 'center', height: '24px', width: '24px', justifyContent: 'center' }}
                    >
                      <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"} style={{ fontSize: '16px' }}></i>
                    </span>
                  </div>
                  {passwordVal && (
                    <div style={{ marginTop: '4px' }}>
                        <p className="error-color-red" style={{ fontSize: '12px', margin: 0 }}>{passwordVal}</p>
                    </div>
                  )}
                </Form.Item>
              </div>

              <div className="login-cinematic-input-wrapper">
                <Form.Item style={{ marginBottom: "2rem" }}>
                  <div style={{ position: 'relative' }}>
                    <Input 
                      className="login-input" 
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleOnChange}
                      type={showConfirmPassword ? "text" : "password"}
                      style={{ paddingRight: '48px', borderColor: confirmPasswordVal ? 'red' : undefined }}
                    />
                    <span 
                      onClick={handleConfirmPassShowHide}
                      style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94a3b8', zIndex: 10, display: 'flex', alignItems: 'center', height: '24px', width: '24px', justifyContent: 'center' }}
                    >
                      <i className={showConfirmPassword ? "fa fa-eye" : "fa fa-eye-slash"} style={{ fontSize: '16px' }}></i>
                    </span>
                  </div>
                  {confirmPasswordVal && (
                    <div style={{ marginTop: '4px' }}>
                        <p className="error-color-red" style={{ fontSize: '12px', margin: 0 }}>{confirmPasswordVal}</p>
                    </div>
                  )}
                </Form.Item>
              </div>

              <Form.Item style={{ marginBottom: "1rem" }}>
                <Button
                  onClick={handlePasswordModal}
                  type="primary"
                  htmlType="button"
                  className="login-cinematic-btn-primary"
                  style={{ width: "100%" }}
                  loading={loading}
                >
                  Update Password
                </Button>
              </Form.Item>
            </Form>

          </div>
        </div>
      </div>

      <footer className="login-cinematic-footer">
        <div className="login-cinematic-footer-links">
          <img
            src={WhiteLabeling?.whiteLebelData?.[0]?.footerLogo || footerCompanyLogo1}
            alt="Logo"
            style={{ height: "18px", filter: "brightness(0) invert(1)", cursor: "pointer" }}
            onClick={() => handleOpenLink(WhiteLabeling?.whiteLebelData?.[0]?.footerLogoLink || "")}
          />
          <Link to={"/termsOfService"}>{t("Terms of Service")}</Link>
          <Link to={"/privacyStatement"}>{t("Privacy Statement")}</Link>
          <a href="#">Copyright 2026 JewelCloud</a>
        </div>
      </footer>

      {/* Password Confirmation Modal */}

      <Modal
        className="delete_conv_modal"
        centered
        visible={updatePasswordModal}
        onOk={handleSubmit}
        onCancel={handleCancelModal}
        width={400}
        footer={[
          <Button key="back" onClick={handleCancelModal}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {t("Update")}
          </Button>,
        ]}
      >
        <div className="col-lg-12">
          <div className="modal__body">
            <div className="col-lg-12">
              <div className="form__fields border-0 p-0">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <p className="subheading reset-pass-conf-text">
                      {t("Are You Sure You Want To Update The Password?")}
                    </p>
                    <h5 className="reset-pass-conf-heading">
                      {t("Please confirm before continuing")}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* End Modal */}
    </div>
  );
};

export default ResetPassword;
